import * as yup from "yup";

export const advertiserValidationSchema = yup.object({
  username: yup.string().required("Username is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords must match")
    .required("Confirm password is required"),
  companyName: yup.string().required("Company name is required"),
  domain: yup.string().required("Domain is required"),
});

export const agencyValidationSchema = yup.object({
  username: yup.string().required("Username is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords must match")
    .required("Confirm password is required"),
  companyName: yup.string().required("Company name is required"),
});

export type IAdvertiserRegister = yup.InferType<
  typeof advertiserValidationSchema
>;
export type IAgencyRegister = yup.InferType<typeof agencyValidationSchema>;
export type IRegister = IAdvertiserRegister | IAgencyRegister;
